'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'bring-front';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f857';
var svgPathData = 'M64 16l96 0c8.8 0 16 7.2 16 16l0 17.1c5.2-.7 10.6-1.1 16-1.1l32 0 0-16c0-35.3-28.7-64-64-64L64-32C28.7-32 0-3.3 0 32l0 96c0 35.3 28.7 64 64 64l16 0 0-32c0-5.4 .4-10.8 1.1-16L64 144c-8.8 0-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16zM352 480c0 35.3 28.7 64 64 64l96 0c35.3 0 64-28.7 64-64l0-96c0-35.3-28.7-64-64-64l-16 0 0 32c0 5.4-.4 10.8-1.1 16l17.1 0c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16l0-17.1c-5.2 .7-10.6 1.1-16 1.1l-32 0 0 16zM192 96c-35.3 0-64 28.7-64 64l0 192c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64L192 96z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBringFront = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;